import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "media",
    name: "%{BKY_CATMEDIA}",
    colour: themeWorkspace.categoryStyles.media_category.colour,
    imageName: "/toolbox-imgs/photo-video-solid.svg",
    id: "10",
    contents: [
      {
        kind: "block",
        type: "image",
        extraState: {
          displaymoreOptions: false,
        },
        fields: {
          moreOptions: false,
        },
        inputs: {
          url: {
            shadow: {
              type: "text",
              fields: {
                TEXT:
                  "https://cdn.pixabay.com/photo/2021/05/24/12/18/lighthouse-6278951_960_720.jpg",
              },
            },
          },
          figure_caption: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "video",
        inputs: {
          embed_code: {
            shadow: {
              type: "text",
              fields: {
                TEXT:
                  '<iframe width="480" height="320" src="https://www.youtube.com/embed/BHACKCNDMW8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
              },
            },
          },
          figure_caption: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "sound",
        inputs: {
          count: {
            block: {
              type: "math_number",
              fields: {
                NUM: 5,
              },
            },
          },
          url: {
            block: {
              type: "text",
              fields: {
                TEXT:
                  "http://codeskulptor-demos.commondatastorage.googleapis.com/pang/pop.mp3",
              },
            },
          },
          figure_caption: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "",
              },
            },
          },
        },
      },
    ],
  };
}
